module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/Logo_SCT_Outil_Libre_Big.9f8baad5.png";